import { Col, Container, Row, Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import muestraMin from "../assets/img/muestra.png";
import muestraN from "../assets/img/muestraN.png";
import muestrS from "../assets/img/muestraStyled.png";
import muestraW from "../assets/img/weather.png";
import muestraA from "../assets/img/muestraA.png";

export const Projects = () => {
  const projects = [
    {
      title: "Modern Page Styled Components",
      description: "Practice of styled components in React.Js, visuals only",
      imgUrl: muestrS,
      direction: "https://styled-components-d9582.web.app/",
    },
    {
      title: "Netflix 2.0",
      description:
        "This Netflix clone is made with React.Js, Redux to manipulate states, firebase and css.",
      imgUrl: muestraN,
      direction: "https://github.com/Maranelo97/Dualface-Net",
    },
    {
      title: "Minecraft.JS",
      description: "Project madded with React.Js, and Three.js",
      imgUrl: muestraMin,
      direction: "https://maincra-a1fd0.web.app/",
    },
    {
      title: "Wheather App Searcher",
      description:
        "This was madded whit React.Js, axios and the OpenWeather API",
      imgUrl: muestraW,
      direction: "https://maranelo97.github.io/weather-Dualface/",
    },
    {
      title: "Movies Searcher",
      description:
        "To acces to the searcher need to use the credentials: 'challenge@alkemy.org' password:'react'",
      imgUrl: muestraA,
      direction: "https://styled-components-d9582.web.app/",
    }
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col>
            <h2>Projects</h2>
            <p>These are my personal projects.</p>
            <Tab.Container id="project-tabs" defaultActiveKey="first">
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Row>
                    {projects.map((project, i) => {
                      return <ProjectCard key={i} {...project} />;
                    })}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="bg" />
    </section>
  );
};
